/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ZoneAssetMapAssetResponseDto } from './ZoneAssetMapAssetResponseDto';
import {
    ZoneAssetMapAssetResponseDtoFromJSON,
    ZoneAssetMapAssetResponseDtoFromJSONTyped,
    ZoneAssetMapAssetResponseDtoToJSON,
    ZoneAssetMapAssetResponseDtoToJSONTyped,
} from './ZoneAssetMapAssetResponseDto';
import type { ZoneResponseDto } from './ZoneResponseDto';
import {
    ZoneResponseDtoFromJSON,
    ZoneResponseDtoFromJSONTyped,
    ZoneResponseDtoToJSON,
    ZoneResponseDtoToJSONTyped,
} from './ZoneResponseDto';
import type { SiteLookupResponseDto } from './SiteLookupResponseDto';
import {
    SiteLookupResponseDtoFromJSON,
    SiteLookupResponseDtoFromJSONTyped,
    SiteLookupResponseDtoToJSON,
    SiteLookupResponseDtoToJSONTyped,
} from './SiteLookupResponseDto';

/**
 * 
 * @export
 * @interface GetZoneAssetsMapResponseDto
 */
export interface GetZoneAssetsMapResponseDto {
    /**
     * 
     * @type {SiteLookupResponseDto}
     * @memberof GetZoneAssetsMapResponseDto
     */
    site: SiteLookupResponseDto;
    /**
     * 
     * @type {ZoneResponseDto}
     * @memberof GetZoneAssetsMapResponseDto
     */
    zone: ZoneResponseDto;
    /**
     * 
     * @type {Array<ZoneAssetMapAssetResponseDto>}
     * @memberof GetZoneAssetsMapResponseDto
     */
    assets: Array<ZoneAssetMapAssetResponseDto>;
}

/**
 * Check if a given object implements the GetZoneAssetsMapResponseDto interface.
 */
export function instanceOfGetZoneAssetsMapResponseDto(value: object): value is GetZoneAssetsMapResponseDto {
    if (!('site' in value) || value['site'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('assets' in value) || value['assets'] === undefined) return false;
    return true;
}

export function GetZoneAssetsMapResponseDtoFromJSON(json: any): GetZoneAssetsMapResponseDto {
    return GetZoneAssetsMapResponseDtoFromJSONTyped(json, false);
}

export function GetZoneAssetsMapResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZoneAssetsMapResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'site': SiteLookupResponseDtoFromJSON(json['site']),
        'zone': ZoneResponseDtoFromJSON(json['zone']),
        'assets': ((json['assets'] as Array<any>).map(ZoneAssetMapAssetResponseDtoFromJSON)),
    };
}

export function GetZoneAssetsMapResponseDtoToJSON(json: any): GetZoneAssetsMapResponseDto {
    return GetZoneAssetsMapResponseDtoToJSONTyped(json, false);
}

export function GetZoneAssetsMapResponseDtoToJSONTyped(value?: GetZoneAssetsMapResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site': SiteLookupResponseDtoToJSON(value['site']),
        'zone': ZoneResponseDtoToJSON(value['zone']),
        'assets': ((value['assets'] as Array<any>).map(ZoneAssetMapAssetResponseDtoToJSON)),
    };
}

